import React, { useContext, useState } from "react";
import GlobalContext from "../context/GlobalContext";

import timingData from "../api/masterTimingData.json";
import machineryData from "../api/masterMachineryData.json";
import dayjs from "dayjs";
import Select from "react-select";
import * as api from "../api/index";

const labelsClasses = [
  "indigo",
  "gray",
  "green",
  "blue",
  "purple",
  "red",
  "orange",
  "pink",
  "cyan",
];

export default function EventModal() {
  const {
    setShowEventModal,
    daySelected,
    //dispatchCalEvent,
    selectedEvent,
    userDetails,
    authenticated,
    filteredEvents,
    setSavedEvents,
  } = useContext(GlobalContext);

  const [machineryID, setMachineryID] = useState(
    selectedEvent ? selectedEvent.machineryID : []
  );
  const [slotStartTime, setSlotStartTime] = useState(
    selectedEvent ? selectedEvent.slotStartTime : ""
  );
  const [slotEndTime, setSlotEndTime] = useState(
    selectedEvent ? selectedEvent.slotEndTime : ""
  );
  const [description, setDescription] = useState(
    selectedEvent ? selectedEvent.description : ""
  );
  const [selectedLabel, setSelectedLabel] = useState(
    selectedEvent
      ? labelsClasses.find((lbl) => lbl === selectedEvent.label)
      : userDetails.result.profileColor
  );

  function handlePunchIn(e, evt) {
    e.preventDefault();
    if (!authenticated) {
      alert("Please Login To Punch In Slot.!!");
      return true;
    }

    if (evt.userName !== userDetails.result.userName) {
      alert("Cannot punch in someone else's slot.");
      return true;
    }
    var PunchType = "IN";
    try {
      api.PunchInorOutEvent({ selectedEvent, PunchType }).then((data) => {
        alert(data.data.message);
        window.location.href = "/";
      });
    } catch (error) {
      alert(error);
    }
  }

  function handlePunchOut(e, evt) {
    e.preventDefault();
    if (!authenticated) {
      alert("Please Login To Punch Out Slot.!!");
      return true;
    }

    if (evt.userName !== userDetails.result.userName) {
      alert("Cannot punch out someone else's slot.");
      return true;
    }
    var PunchType = "OUT";
    try {
      api.PunchInorOutEvent({ selectedEvent, PunchType }).then((data) => {
        alert(data.data.message);

        if (!data.data.success) return true;

        window.location.href = "/";
      });
    } catch (error) {
      alert(error);
    }
  }

  function handleDelete(e, evt) {
    e.preventDefault();

    if (!authenticated) {
      alert("Please Login To Delete Slot.!!");
      return true;
    }

    if (evt.userName !== userDetails.result.userName) {
      alert("Cannot delete someone else's slot.");
      return true;
    }

    var retVal = window.confirm("Do you want to continue ?");
    if (!retVal) {
      return true;
    }

    try {
      api.DeleteEvent({ evt }).then((data) => {
        alert(data.data.message);

        if (!data.data.success) return true;

        setSavedEvents(filteredEvents.filter((ev) => ev._id !== evt._id));
        window.location.href = "/";
      });
    } catch (error) {
      alert(error);
    }
  }

  function getPunchInorOutClass(date, type) {
    let classType = date != null && date !== "" ? "style-pointer-none" : "";
    if (
      type === "OUT" &&
      (selectedEvent.punchInTime == null || selectedEvent.punchInTime === "")
    )
      classType = "style-pointer-none";
    return classType;
  }

  function handleSubmit(e) {
    e.preventDefault();

    var selectedDate = daySelected.format("MM-DD-YYYY");

    if (selectedDate < dayjs().format("MM-DD-YYYY")) {
      alert("Cannot book previous dat slots.");
      return true;
    }

    const calendarEvent = {
      machineryID,
      description,
      slotStartTime,
      slotEndTime,
      label: selectedLabel,
      slotDay: selectedDate,
      id: selectedEvent ? selectedEvent.id : Date.now(),
      createdDate: dayjs().format("MM-DD-YYYY"),
      userName: userDetails.result.userName,
    };

    if (selectedEvent) {
      setShowEventModal(false);
    } else {
      try {
        api.SaveEvent(calendarEvent).then((data) => {
          alert(data.data.message);
          if (data.data.success) {
            data.data.result.forEach((ev) => {
              setSavedEvents([...filteredEvents, ev]);
            });
            window.location.href = "/";
          }
        });
      } catch (error) {
        alert(error);
      }
    }

    setShowEventModal(false);
  }
  return (
    <div className="h-screen w-full fixed left-0 top-0 flex justify-center items-center">
      <form className="bg-white rounded-lg shadow-2xl w-1/4">
        <header className="bg-gray-100 px-4 py-2 flex justify-between items-center">
          <span className="material-icons-outlined text-gray-400">
            drag_handle
          </span>
          <div>
            {selectedEvent && (
              <span
                onClick={(e) => {
                  handleDelete(e, selectedEvent);
                  setShowEventModal(false);
                }}
                className="material-icons-outlined text-gray-400 cursor-pointer"
              >
                delete
              </span>
            )}
            <button onClick={() => setShowEventModal(false)}>
              <span className="material-icons-outlined text-gray-400">
                close
              </span>
            </button>
          </div>
        </header>
        <div className="p-2">
          <div className="grid grid-cols-1/8 items-end gap-y-5">
            <div></div>

            <div
              className={`flex-rows-center ${
                selectedEvent && "style-pointer-none"
              }`}
            >
              <div className="flex-rows-w-45">
                <span className="material-icons-outlined text-gray-400">
                  schedule
                </span>
                <p>{daySelected.format("dddd, MMMM DD")}</p>
              </div>
              <div className="flex-rows-center col-gap-15">
                <select
                  name="slotStartTime"
                  required
                  value={slotStartTime}
                  className="pt-1 border-0 text-gray-600 pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
                  onChange={(e) => setSlotStartTime(e.target.value)}
                >
                  <option>Select start time</option>
                  {timingData.map((item, idx) => (
                    <option value={item.value} key={idx}>
                      {item.label}
                    </option>
                  ))}
                </select>

                {slotStartTime && (
                  <select
                    name="slotEndTime"
                    required
                    value={slotEndTime}
                    className="pt-1 border-0 text-gray-600 pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
                    onChange={(e) => setSlotEndTime(e.target.value)}
                  >
                    <option>Select end time</option>
                    {timingData.map((item, idx) => (
                      <>
                        {item.value <= slotStartTime ? (
                          <option disabled value={item.value} key={idx}>
                            {item.label}
                          </option>
                        ) : (
                          <option value={item.value} key={idx}>
                            {item.label}
                          </option>
                        )}
                      </>
                    ))}
                  </select>
                )}
              </div>
            </div>

            <Select
              isMulti
              isSearchable
              name="machineryID"
              options={machineryData}
              className={`basic-multi-select ${
                selectedEvent && "style-pointer-none"
              }`}
              classNamePrefix="select"
              value={machineryID}
              onChange={setMachineryID}
            />

            <input
              type="text"
              name="description"
              placeholder="Add a remark"
              value={description}
              required
              className={`pt-3 border-0 text-gray-600 pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500 ${
                selectedEvent && "style-pointer-none"
              }`}
              onChange={(e) => setDescription(e.target.value)}
            />

            <div
              className={`flex-rows-center ${
                selectedEvent && "style-pointer-none"
              }`}
            >
              <span className="material-icons-outlined text-gray-400">
                bookmark_border
              </span>
              <div className="flex gap-x-2">
                {labelsClasses.map(
                  (lblClass, i) =>
                    selectedLabel === lblClass && (
                      <span
                        key={i}
                        onClick={() => setSelectedLabel(lblClass)}
                        className={`bg-${lblClass}-500 w-6 h-6 rounded-full flex items-center justify-center cursor-pointer`}
                      >
                        <span className="material-icons-outlined text-white text-sm">
                          check
                        </span>
                      </span>
                    )
                )}
              </div>
            </div>
            <div className="flex-rows-center">
              {selectedEvent && (
                <>
                  <div className="punchBTNdiv">
                    <button
                      onClick={(e) => {
                        handlePunchIn(e, selectedEvent);
                        setShowEventModal(false);
                      }}
                      className={`bg-green-500 hover:bg-gray-600 px-6 py-2 rounded text-white ${getPunchInorOutClass(
                        selectedEvent.punchInTime,
                        "IN"
                      )}`}
                    >
                      In
                    </button>
                    <h5 className="font-xx-small">
                      <strong>{selectedEvent.punchInTime}</strong>
                    </h5>
                  </div>
                  <div className="punchBTNdiv">
                    <button
                      onClick={(e) => {
                        handlePunchOut(e, selectedEvent);
                        setShowEventModal(false);
                      }}
                      className={`bg-red-500 hover:bg-gray-600 px-6 py-2 rounded text-white ${getPunchInorOutClass(
                        selectedEvent.punchOutTime,
                        "OUT"
                      )}`}
                    >
                      Out
                    </button>
                    <h5 className="font-xx-small">
                      <strong>{selectedEvent.punchOutTime}</strong>
                    </h5>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <footer className="flex justify-end border-t p-3 mt-5">
          <button
            type="submit"
            onClick={(e) => {
              handleSubmit(e);
              setShowEventModal(false);
            }}
            className="bg-blue-500 hover:bg-blue-600 px-6 py-2 rounded text-white"
          >
            {selectedEvent ? "Close" : "Save"}
          </button>
        </footer>
      </form>
    </div>
  );
}
